module.exports = __webpack_public_path__ + "static/numbers-en-04366720a8d9373eee67fb2f3b340d4d.svg";